import React from "react";
import { useNavigate } from "react-router-dom";
import { FilterDialogScreen } from "web/react/components/filter-redesign/filter-dialog/filter-dialog-screen";
import { SizePill, SizePills } from "web/react/components/size-pills/size-pills";
import { useActiveFilters, useFilter, useFilterSync } from "web/react/hooks/filters";
import styles from "./filters-sizes-screen.module.css";

export function FiltersSizesScreen(): JSX.Element | null {
    const { label, options } = useFilter("sizes");
    const { isActive } = useActiveFilters();
    const { onChange } = useFilterSync();
    const navigate = useNavigate();

    const pills = options.map(
        (option): SizePill => ({
            id: option.id,
            url: option.url,
            label: option.label,
            checked: isActive(option),
            onClick: () => onChange(option.url),
        })
    );

    return (
        <FilterDialogScreen title={label} onBack={() => navigate("/")}>
            <SizePills pills={pills} className={styles.wrapper} />
        </FilterDialogScreen>
    );
}
